module.exports = __webpack_public_path__ + "static/media/pink-template-big.94cfd291.png";